import _, { indexOf } from 'lodash';
import validator from 'validator';
import superagent from "superagent";
const axios = require('axios');
const qs    = require('querystring');
const formConfig = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
}

// export const GetGateEvents = (gate_id) => {
//     return (dispatch, getState, {getFirebase}) => {
//         // const firebase = getFirebase();
//         // const firestore = firebase.firestore();

//         fetch(`http://157.230.161.116:4000/api/v1/gate/${gate_id}/log`)
//     }
// }

export const DeleteUserFromGate = (gate_id, user_id) => {
    return async (dispatch, getState, {getFirebase}) => {
        const firebase = getFirebase();
        const firestore = firebase.firestore();

        await firestore
            .collection("gates")
            .doc(gate_id)
            .collection("users")
            .doc(user_id)
            .delete();

        await firestore
            .collection("users")
            .doc(user_id)
            .set(
                { gates: firebase.firestore.FieldValue.arrayRemove(gate_id) },
                { merge: true }
            );

        return 1;
    }
}

export const UpsertUser = (gate_id, formData) => {
    return async (dispatch, getState, {getFirebase}) => {
        const firebase = getFirebase();
        const firestore = firebase.firestore();
        
        const { newID, id, phone, isGuest, isAdmin, wiegand, facility, keycode, textOnOpen, textOnTamper, textOnSensorFail } = formData;

        let data = { name: formData.name, };
        
        if( isAdmin ) data["isAdmin"] = true;

        if( !isAdmin ) {
            data["accessTime"]  = formData.accessTime;

            if( isGuest ) {
                data["isGuest"]     = true;

                let state = getState();
                let timeDiff = state.gate.gate.timeDiff;

                let startTime = new Date(formData.startTime.unix() * 1000);
                let newStart  = new Date(startTime.getFullYear(), startTime.getMonth(), startTime.getDate(), 0, 0, 0);

                let expireTime = new Date(formData.expireTime.unix() * 1000);
                let newExpire  = new Date(expireTime.getFullYear(), expireTime.getMonth(), expireTime.getDate(), 23, 59, 59);
                
                // expireTime.setSeconds(-1);

                data["startTime"]   = newStart.getTime();
                data["expireTime"]  = newExpire.getTime();
            }
        }
        
        if ( phone ) {
            data["phone"]               = phone;
            if( isAdmin ) {
                data["textOnOpen"]          = textOnOpen          ? true : false;
                data["textOnTamper"]        = textOnTamper        ? true : false;
                data["textOnSensorFail"]    = textOnSensorFail    ? true : false;
            }
        }

        if( !isGuest ) {
            data["wiegand"]   = wiegand  ? wiegand : "";
            data["facility"]  = facility ? facility : "";
            data["keycode"]   = keycode  ? keycode : "";
            data["isAdmin"]   = isAdmin  ? true : false ; 

        }


        if( id || phone ) { //Upsert
            let userID = newID ? newID : id;
            if( !isGuest ) { //For Users || Admins
                if( newID && id ) { //A Change in Phone Number
                    await firestore.collection("gates").doc(gate_id).collection("users").doc(id).delete();
                    await firestore.collection("users").doc(id).set({ gates: firebase.firestore.FieldValue.arrayRemove(gate_id) },{ merge: true });
                }
                await firestore.collection("users").doc(userID).set({ gates: firebase.firestore.FieldValue.arrayUnion(gate_id) },{ merge: true });
            } else { //For Guests
                //Check if we are updating / creating
                if( !userID ) {
                    let user = await firestore.collection("gates").doc(gate_id).collection("users").doc();
                    userID = user.id;
                }
                await fetch(`https://us-central1-maximum-controls-app.cloudfunctions.net/api/v1/gates/${gate_id}/invite/${user.id}`);
            }

            await firestore
                .collection("gates")
                .doc(gate_id)
                .collection("users")
                .doc(userID)
                .set( data,{merge: true} );

            if( id ) {
                if( isGuest )       await eventLog(gate_id, `Updated Guest "${data.name}" by`);
                else if( isAdmin )  await eventLog(gate_id, `Updated Admin "${data.name}" by`);
                else                await eventLog(gate_id, `Updated User "${data.name}" by`);
            } else {
                if( isGuest )       await eventLog(gate_id, `Invited a Guest "${data.name}" by`);
                else if( isAdmin )  await eventLog(gate_id, `Created an Admin "${data.name}" by`);
                else                await eventLog(gate_id, `Created a User "${data.name}" by`);
            }

            let state = getState();
            let users = state.gate.users;
            let user = users.find( user => user.user_id === userID );
            let newData = {...users[users.indexOf(user)], ...data};
            users[users.indexOf(user)] = newData;
            dispatch({ type: 'GET_GATE_USERS', users: [...users] });

        } else { //Create - Regular Wiegand/Keycode User (w/ No Phone) or Guest
            let user = await firestore.collection("gates").doc(gate_id).collection("users").doc();
            user.set( data );
        }

        return 1;
    };
}

export const OpenGate = (gate_id, key) => {
    return async (dispatch, getState, {getFirebase}) => {
        const firebase = getFirebase();
        const firestore = firebase.firestore();

        let code = window.localStorage.getItem("key");

        let data = { 
            currentAction: "open_gate",
            key: key,
            guestCode: code
        };

        // last_action_by: { 
        //     accessTimes: guest.accessTimes, 
        //     name: guest.name, 
        //     phone: guest.phone, 
        //     user_id: key, 
        //     action: "open_gate" 
        // } 

        await firestore.collection("gates").doc(gate_id).collection("private").doc("data").set( data , { merge: true });
            
    }
};

export const CloseGate = (gate_id, key) => {
    return async (dispatch, getState, {getFirebase}) => {
        const firebase = getFirebase();
        const firestore = firebase.firestore();

        let code = window.localStorage.getItem("key");

        let data = { 
            currentAction: "close_gate",
            key: key,
            guestCode: code
        };
        await firestore.collection("gates").doc(gate_id).collection("private").doc("data").set( data , { merge: true });
            
    }
};

export const GetGuest = (gate_id, user_id) => {
    return async (dispatch, getState, {getFirebase}) => {
        const firebase = getFirebase();
        const firestore = firebase.firestore();
        
        let key = window.localStorage.getItem( "key" );
        let verifyKey = await superagent.get(`https://us-central1-maximum-controls-app.cloudfunctions.net/api/v1/verify/key/${gate_id}/${user_id}/${key}`);
        let keyResult = verifyKey.body;
        
        if ( key && keyResult.error ) {
            window.localStorage.removeItem( "key" )
            window.location.reload();
        }

        let guestResponse = await superagent.get(`https://us-central1-maximum-controls-app.cloudfunctions.net/api/v1/guest/${gate_id}/${user_id}`);
        let result = guestResponse.body;
        dispatch({ type: 'GUEST_DATE', date: result.date });
    
        firestore.collection("gates").doc(gate_id).onSnapshot((snapshot) => {
            let gate = snapshot.exists ? snapshot.data() : {};
            dispatch({ type: 'GUEST_GATE', gate: gate });
        });
    
        firestore.collection("gates")
            .doc(gate_id)
            .collection("users")
            .doc(user_id)
            .collection("public")
            .doc("data")
            .onSnapshot((snapshot) => {
                console.log(snapshot.exists);
                if( snapshot.exists ) {
                    dispatch({ type: 'SET_GUEST', guest: snapshot.data() });
                } else {
                    dispatch({ type: 'GUEST_EXPIRE', isExpired: true });
                }
            });
        

    }
}

export const GetGates = () => {
    return async (dispatch, getState, {getFirebase}) => {
        const firebase = getFirebase();
        const firestore = firebase.firestore();

        return firestore.collection("gates").onSnapshot(async (snapshot) => {
            // console.log(`${new Date().toUTCString()} - Changes Detected`);
            let gates = [];
            snapshot.forEach(async doc => {
                let data = doc.data();
                data.id = doc.id;
                // let gateData = await firestore.collection("gates").doc(doc.id).collection("private").doc("data").get();
                // let gate = gateData.data();
                // let pushData = {...data, address: gate.address};
                if( !data.name ) data.name = "[NO NAME]";
                gates.push(data);
            });

            let getData = async () => { 
                return Promise.all(gates.map( async gate => {
                    let gate_snapshot = await firestore.collection("gates").doc(gate.id).collection("private").doc("data").get();
                    let gateData = {};
                    if ( gate_snapshot.exists ) {
                        let gateData = gate_snapshot.data();
                    }
                    return await { ...gate, address: gateData.address ? gateData.address : "" };
                
                }))
            };
            let gateData = await getData();
            dispatch({ type: 'GET_GATES', gates: gateData });
        });
        
    }
}

// export const DenyVerify = (gate_id) => {
//     return async (dispatch, getState, {getFirebase}) => {
//         const firebase = getFirebase();
//         const firestore = firebase.firestore();
//         const gateCreateCallable = await firebase.functions().httpsCallable('functionsGatesLogs');
//         let logs = await gateCreateCallable({id: gate_id}).then(result => result);
//         return logs;
//     }
// };
// export const GuestVerify = (gate_id) => {
//     return async (dispatch, getState, {getFirebase}) => {
//         const firebase = getFirebase();
//         const firestore = firebase.firestore();
//         const gateCreateCallable = await firebase.functions().httpsCallable('functionsGatesLogs');
//         let logs = await gateCreateCallable({id: gate_id}).then(result => result);
//         return logs;
//     }
// };
// export const GuestCode = (gate_id) => {
//     return async (dispatch, getState, {getFirebase}) => {
//         const firebase = getFirebase();
//         const firestore = firebase.firestore();
//         const gateCreateCallable = await firebase.functions().httpsCallable('functionsGatesLogs');
//         let logs = await gateCreateCallable({id: gate_id}).then(result => result);
//         return logs;
//     }
// };

export const GetGateLogs = (gate_id) => {
    return async (dispatch, getState, {getFirebase}) => {
        const firebase = getFirebase();
        const firestore = firebase.firestore();
        const gateCreateCallable = await firebase.functions().httpsCallable('functionsGatesLogs');
        let logs = await gateCreateCallable({id: gate_id}).then(result => result);
        return logs;
    }
};

export const CreateGate = (data) => {
    return async (dispatch, getState, {getFirebase}) => {
        const firebase = getFirebase();
        const firestore = firebase.firestore();
        // let formData = { ...data, wsOnline: true };

        //Check WSOnline

        let formData = {
            name:                   data.name,
            max_id:                 data.max_id,
            wsOnline:               data.wsOnline,
            address:                data.address,
            greeting:               data.greeting,
            callMsg:                data.callMsg,
            forceCode:              data.forceCode,
            admin_name:             data.admin_name,
            admin_phone:            data.admin_phone, //Required
            admin_keycode:          data.admin_keycode,
            admin_wiegand:          data.admin_wiegand,
            admin_textOnOpen:       false, //data.admin_textOnOpen,
            admin_textOnTamper:     false, //data.admin_textOnTamper,
            admin_textOnSensorFail: false, //data.admin_textOnSensorFail,
        };

        const gateCreateCallable = await firebase.functions().httpsCallable('functionsGatesCreateGate');
        let gate = await gateCreateCallable(formData).then(result => result.data);

        return gate.id;
    }
}

export const DeleteGate = (gate_id) => {
    return async (dispatch, getState, {getFirebase}) => {
        const firebase  = getFirebase();
        // const firestore = firebase.firestore();
        // let users_snapshot = await firestore.collection("gates").doc(gate_id).collection("users").get();
        // users_snapshot.forEach(user => {
        //     firestore
        //     .collection("users").doc(user.id)
        //     .collection("gates").doc(gate_id)
        //     .set({ gates: firebase.firestore.FieldValue.arrayRemove(gate_id) }, {merge: true});
        // });

        var deleteGate = firebase.functions().httpsCallable('functionsGatesRecursiveDelete');
        await deleteGate({ id: gate_id })
        .then(function(result) {
            console.log('Delete success: ' + JSON.stringify(result));
        })
        .catch(function(err) {
            console.log('Delete failed, see console,');
            console.warn(err);
        });

        if( !alert('Gate Deleted! Returning to Gate List.') ){ window.location = "/admin/gates"; }
    };
}

export const QueueAction = (gate_id, action) => {
    return async (dispatch, getState, {getFirebase}) => {
        const firebase = getFirebase();
        const firestore = firebase.firestore();

        let meta_ref = await firestore
            .collection( "gates" )
            .doc( gate_id )
            .collection( "private" )
            .doc( "data" )
            .get();

        let meta_data = meta_ref.data();
        
        if( !meta_data.queued_actions.includes(action) ) {
            meta_data.queued_actions.push(action);

            if( action === "update_timers" ) {
                eventLog(gate_id , `Sync Schedules by`);
            }

            await firestore
            .collection( "gates" )
            .doc( gate_id )
            .collection( "private" )
            .doc( "data" )
            .set( meta_data );
        }

    }
}

export const UpdateTimer = (gate_id, i, data) => {
    return async (dispatch, getState, {getFirebase}) => {
        const firebase = getFirebase();
        const firestore = firebase.firestore();

        await firestore
            .collection( "gates" )
            .doc( gate_id )
            .collection( "timers" )
            .doc( (i + 1).toString() )
            .set( data );
       
        dispatch({ type: 'UPDATE_TIMES', i: i, time: data });
    }
}

export const GetGateTimes = (gate_id) => {
    return async (dispatch, getState, {getFirebase}) => {
        const firebase = getFirebase();
        const firestore = firebase.firestore();
        let time_snapshots = await firestore
            .collection( "gates" )
            .doc( gate_id )
            .collection( "timers" )
            .get();
        let times = []
        time_snapshots.docs.forEach(time => times.push(time.data()));
        dispatch({ type: 'GET_GATE_TIMES', times: times });
    }
}

export const UpdateGate = (id, data, old) => {
    return async (dispatch, getState, {getFirebase}) => {
        const firebase = getFirebase();
        const firestore = firebase.firestore();
        let gate = {...data};

        //Check if MAX Id exist
        //Check that MAX id is Set
        //Check if Gate Name is Set
        
        //Update Block
        if( old.name !== data.name ) {
            eventLog( id, "Site Name updated by" )
        }
        if( old.address !== data.address ) {
            eventLog( id, "Address updated by" )
        }
        if( old.max_id !== data.max_id ) {
            eventLog( id, "MAX ID changed by" )
        }
        if( old.callMsg !== data.callMsg ) {
            eventLog( id, "Call MSG updated by" )
        }
        if( old.greeting !== data.greeting ) {
            eventLog( id, "Greetings updated by" )
        }
        if( old.forceCode !== data.forceCode ) {
            eventLog( id, "Force Open Keycode updated by" )
        }

        await firestore.collection("gates").doc(id).collection("private").doc("data").set(gate, {merge: true});
        await firestore.collection("gates").doc(id).set({
            name: gate.name,
            max_id: gate.max_id
        }, {merge: true});

        dispatch({ type: 'UPDATE_GATE', gate: gate });
        alert("Updated!");
    }
}

export const ClearGates = () => {
    return async (dispatch, getState, {getFirebase}) => {
        dispatch({ type: 'CLEAR_GATES' });
    }
};

export const GetQueuedActions = (gate_id) => {
    return async (dispatch, getState, {getFirebase}) => {
        const firebase  = getFirebase();
        const firestore = firebase.firestore();
        return firestore
            .collection("gates")
            .doc(gate_id)
            .collection("private")
            .doc("data")
            .onSnapshot(async (snapshot) => {
                if(snapshot.exists) {
                    let metaData    = snapshot.data();
                    let state       = getState();
                    
                    metaData.queued_actions.length !== state.gate.privates.queued_actions.length
                    && dispatch({ type: 'UPDATE_GATE_PRIVATES', privates: snapshot.data() });
                }
        });
    }
};

export const GetGateUsers = (gate_id) => {

    return async (dispatch, getState, {getFirebase}) => {
        const firebase   = getFirebase();
        const firestore  = firebase.firestore();

        return firestore
        .collection("gates").doc(gate_id)
        .collection("users").onSnapshot(async (snapshot) => {
            let users = [];
            snapshot.forEach(doc => {
                let data = doc.data();
                data.id = doc.id;
                users.push(data);
            });        
            // let state = getState();
            // users.length !== state.gate.users.length && dispatch({ type: 'GET_GATE_USERS', users: users });
            dispatch({ type: 'GET_GATE_USERS', users: users });
        });
    }
}

export const GetGateDetails = (gate_id) => {
    return async (dispatch, getState, {getFirebase}) => {
        const firebase  = getFirebase();
        const firestore  = firebase.firestore();
        let gate_ref = await firestore.collection("gates").doc(gate_id).collection("private").doc("data").get();
        let gate = {};
        if( gate_ref.exists ) {
            gate = gate_ref.data();
            let gate_logs = await firestore.collection("gates").doc(gate_id).collection("private").doc("logs").get();
            if( gate_logs.exists ) {
                gate.errors = gate_logs.data().errors;
            }
        } else {
            gate = { exist: false };
        }
        dispatch({ type: 'GET_GATE_DETAILS', gate: gate });
    }
}

const eventLog = async ( gateID, summary ) => {
    let post_url = `https://us-central1-maximum-controls-app.cloudfunctions.net/api/v1/event/${gateID}`;
    let result = await axios.post(
        post_url, 
        { summary: `${summary} MAX Tech Support` }, 
    );
}
